export default "__VITE_ASSET__Vr$_2qD6__"